import { render, staticRenderFns } from "./formbuilderLogsWidget.vue?vue&type=template&id=e2b6e2b8&scoped=true"
import script from "./formbuilderLogsWidget.vue?vue&type=script&lang=js"
export * from "./formbuilderLogsWidget.vue?vue&type=script&lang=js"
import style0 from "./formbuilderLogsWidget.vue?vue&type=style&index=0&id=e2b6e2b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2b6e2b8",
  null
  
)

export default component.exports